var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("header", { staticClass: "header header--protein" }, [
        _c("div", { staticClass: "header__container" }, [
          _c("div", { staticClass: "header__row" }, [
            _c("a", {
              staticClass: "prev prev--white",
              attrs: { href: "/myprotein-result", "aria-label": "이전" }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v("\n\t\t\t\t\t우리 몸에서 수분 다음으로"),
            _c("br"),
            _vm._v("\n\t\t\t\t\t많은 성분 ‘단백질’\n\t\t\t\t")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c(
          "div",
          { staticClass: "contents__contents contents__contents--overlap" },
          [
            _c("p", { staticClass: "desc desc--secondary" }, [
              _vm._v(
                "\n\t\t\t\t\t단백질은 근육, 손톱, 머리카락 등 신체 조직을 구성하고 에너지를 합성하며, 체내 필수 영양소를 운반하는 등 "
              ),
              _c("span", { staticClass: "line-highlight" }, [
                _vm._v("우리 몸의 16%를 차지하는 중요한 영양소입니다.")
              ]),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n\t\t\t\t\t우리 몸속에 단백질의 형태로 축적되지 않기에\n\t\t\t\t\t매일 꾸준하게 드시는 것이 중요합니다.\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("./assets/images/protein01.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "etc" }, [
              _vm._v(
                "\n\t\t\t\t\t*출처: Hoffman, Jay R., and Michael J. Falvo. “Protein-which is best?.” Journal of sports science & medicine 3.3 (2004): 118."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\t\t\tDuda, K., Majerczak, J., Nieckarz, Z., Heymsfield, S. B., & Zoladz, J. A. (2019). Human Body Composition and Muscle Mass. Muscle and Exercise Physiology, 3-26.\n\t\t\t\t"
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa8ac08e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa8ac08e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinInfo01.vue
// module id = 5i6I
// module chunks = 0